










































import { Component, Mixins, Watch } from 'vue-property-decorator';
import Modal from './company-margins.modal.vue';
import TableMixin from '@/mixins/table.mixin';

@Component({
  components: { Modal },
})
export default class CompanyMarkupsShell extends Mixins(TableMixin) {
  normalizeDate(date: Date) {
    return date ? this.$formatDate(date) : '';
  }

  columns = [
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    { label: 'GENERAL.NAME', name: 'name', sortable: true },
    { label: 'GENERAL.SUPPLIERS', name: 'suppliers', sortable: true, field: (row: any) => row.suppliers.length },
    { label: 'GENERAL.BUYERS', name: 'buyers', sortable: true, field: (row: any) => row.buyers.length },
    { label: 'GENERAL.PROPERTIES', name: 'properties', sortable: true, field: (row: any) => row.properties.length },
    {
      label: 'GENERAL.BOOKING_START_DATE',
      name: 'bookingStartDate',
      sortable: true,
      field: (row: any) => this.normalizeDate(row.bookingStartDate),
    },
    {
      label: 'GENERAL.BOOKING_END_DATE',
      name: 'bookingEndDate',
      sortable: true,
      field: (row: any) => this.normalizeDate(row.bookingEndDate),
    },
    {
      label: 'GENERAL.MIN_CHECK_IN_DATE',
      name: 'minCheckInDate',
      sortable: true,
      field: (row: any) => this.normalizeDate(row.minCheckInDate),
    },
    {
      label: 'GENERAL.MAX_CHECK_IN_DATE',
      name: 'maxCheckInDate',
      sortable: true,
      field: (row: any) => this.normalizeDate(row.maxCheckInDate),
    },
    {
      label: 'GENERAL.APPLICATION_TYPE',
      name: 'applicationType',
      sortable: true,
    },
    {
      label: 'GENERAL.MARGIN_TYPE',
      name: 'type',
      sortable: true,
    },
    {
      label: 'GENERAL.MARGIN_UNIT',
      name: 'unit',
      sortable: true,
    },
    {
      label: 'GENERAL.MARGIN_VALUE',
      name: 'value',
      sortable: true,
    },
    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];

  @Watch('modal.open')
  onClose(value: boolean) {
    if (!value) this.onUpdateData();
  }
}
